import { createContext, useContext } from 'react';

export interface SubSidebarContextType {
  isOpen: boolean;
  isExpanded: boolean;
  currentPath: string;
  openSubSidebar: () => void;
  closeSubSidebar: () => void;
  toggleSubSidebar: () => void;
  expandSubSidebar: () => void;
  collapseSubSidebar: () => void;
  toggleExpandSubSidebar: () => void;
  setCurrentPath: (path: string) => void;
}

export const SubSidebarContext = createContext<SubSidebarContextType | undefined>(undefined);

export function useSubSidebar() {
  const context = useContext(SubSidebarContext);
  if (context === undefined) {
    throw new Error('useSubSidebar must be used within a SubSidebarProvider');
  }
  return context;
}
